/* eslint-disable complexity */
import {createSlice} from '@reduxjs/toolkit';
import {defaultMenuType, subHiddenBreakpoint, menuHiddenBreakpoint} from '../constants/defaultValues';
import {resetSlicesToInitialState} from './userSlice';

const initialState = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  menuClickCount: 0,
  selectedMenuHasSubItems: defaultMenuType === 'menu-default', // if you use menu-sub-hidden as default menu type, set value of this variable to false
};

/**
 * Menu Store Slice
 */
const slice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    addContainerClassname: (state, {payload}) => {
      state.containerClassnames = payload;
    },
    changeDefaultClassnames: (state, {payload}) => {
      state.containerClassnames = payload;
    },
    changeSelectedMenuHasSubItems: (state, {payload}) => {
      state.selectedMenuHasSubItems = payload;
    },
    clickOnMobileMenu: (state, {payload}) => {
      const currentClasses = payload
        ? payload
          .split(' ')
          .filter(x => x !== '' && x !== 'sub-show-temporary')
        : '';
      let nextClasses = '';
      if (currentClasses.includes('main-show-temporary')) {
        nextClasses = currentClasses
          .filter(x => x !== 'main-show-temporary')
          .join(' ');
      } else {
        nextClasses = `${currentClasses.join(' ')} main-show-temporary`;
      }
      state.containerClassnames = nextClasses;
      state.menuClickCount = 0;
    },
    setContainerClassnames: (state, {payload}) => {
      const {clickIndex, strCurrentClasses, selectedMenuHasSubItems} = payload;
      let newClickIndex = clickIndex;
      const currentClasses = strCurrentClasses
        ? strCurrentClasses.split(' ').filter(x => x !== '')
        : '';
      let nextClasses = '';
      if (!selectedMenuHasSubItems) {
        if (
          currentClasses.includes('menu-default')
          && (clickIndex % 4 === 0 || clickIndex % 4 === 3)
        ) {
          newClickIndex = 1;
        }
        if (currentClasses.includes('menu-sub-hidden') && newClickIndex % 4 === 2) {
          newClickIndex = 0;
        }
        if (
          currentClasses.includes('menu-hidden')
          && (newClickIndex % 4 === 2 || newClickIndex % 4 === 3)
        ) {
          newClickIndex = 0;
        }
      }

      if (newClickIndex % 4 === 0) {
        if (
          currentClasses.includes('menu-default')
          && currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden';
        }
        newClickIndex = 0;
      } else if (newClickIndex % 4 === 1) {
        if (
          currentClasses.includes('menu-default')
          && currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      } else if (newClickIndex % 4 === 2) {
        if (
          currentClasses.includes('menu-default')
          && currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary sub-show-temporary';
        }
      } else if (newClickIndex % 4 === 3) {
        if (
          currentClasses.includes('menu-default')
          && currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      }
      if (currentClasses.includes('menu-mobile')) {
        nextClasses += ' menu-mobile';
      }
      state.containerClassnames = nextClasses;
      state.menuClickCount = newClickIndex;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetSlicesToInitialState, () => initialState);
  },
});

export const {
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems,
  clickOnMobileMenu,
  setContainerClassnames,
} = slice.actions;

export default slice.reducer;
